import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-national-coupon-payments',
  templateUrl: './national-coupon-payments.component.html',
  styleUrls: ['./national-coupon-payments.component.scss']
})
export class NationalCouponPaymentsComponent implements OnInit {

  constructor(
    private _router: Router,
  ) { }

  ngOnInit(): void {
  }

  // On filter change
  async onfilterChange(event: any) {
    if (event.coupon_source == "cpg") {
      this._router.navigate(['/retailer/payments']); // Go to regional payments
    } else {

    }
  }

}
